import React from 'react'
import cn from 'classnames'
import { Block } from '@contentful/rich-text-types'
import { useGetListItemStyles } from './hooks/use-get-list-item-styles'

interface ListItemProps extends Block {
  children?: React.ReactNode
}

export const ListItem: React.FC<ListItemProps> = (props) => {
  const { content, children } = props

  const listItemStyles = useGetListItemStyles(content)

  return <li className={cn(listItemStyles)}>{children}</li>
}
